module.exports = __webpack_public_path__ + "img/icon_7.5552aabc.png";